import React from 'react';
import Type from 'prop-types';
import { List, ListItem, ListItemText, ListItemIcon, Divider } from '@material-ui/core';
import {
  Person as PersonIcon,
  AttachMoney as AttachMoneyIcon,
  ChatBubble as ChatBubbleIcon,
  DateRange as DateRangeIcon,
  Alarm as AlarmIcon,
} from '@material-ui/icons';
import { Amount } from 'components';
import { getDateTimePickerFormat, shortDateFullMonthFullYearFormat } from 'utils/date';
import { ru } from 'locale';
import { statusIcons } from './DecisionItem.mock';
import useStyles from './DecisionItem.styles';

const DecisionItem = props => {
  const classes = useStyles();
  const { decision, onEdit } = props;
  const formattedDate = getDateTimePickerFormat(decision.dateTo, shortDateFullMonthFullYearFormat);
  const { status } = decision;
  const Icon = statusIcons[status];

  const handleFormDialogOpen = name => () => {
    onEdit(name);
  };

  const renderAmount = value => {
    return (
      <Amount
        amount={{
          value,
          currency: { code: 'RUR', minority: 0 },
        }}
      />
    );
  };

  return (
    <List aria-label={ru.decision}>
      <ListItem>
        <ListItemIcon>
          <PersonIcon />
        </ListItemIcon>
        <ListItemText primary={ru.name} secondary={decision.userName} />
      </ListItem>
      <Divider />
      <ListItem
        button
        aria-haspopup="true"
        aria-controls="form-dialog"
        aria-label={ru.limit}
        onClick={handleFormDialogOpen('limit')}
        role="listitem"
      >
        <ListItemIcon>
          <AttachMoneyIcon />
        </ListItemIcon>
        <ListItemText primary={ru.limit} secondary={renderAmount(decision.limit)} />
      </ListItem>
      <Divider />
      <ListItem
        button
        aria-haspopup="true"
        aria-controls="form-dialog"
        aria-label={ru.term}
        onClick={handleFormDialogOpen('term')}
      >
        <ListItemIcon>
          <AlarmIcon />
        </ListItemIcon>
        <ListItemText primary={ru.term} secondary={decision.term} />
      </ListItem>
      <Divider />
      <ListItem
        button
        aria-haspopup="true"
        aria-controls="form-dialog"
        aria-label={ru.comment}
        onClick={handleFormDialogOpen('comment')}
      >
        <ListItemIcon>
          <ChatBubbleIcon />
        </ListItemIcon>
        <ListItemText primary={ru.comment} secondary={decision.comment} />
      </ListItem>
      <Divider />
      <ListItem
        button
        aria-haspopup="true"
        aria-controls="form-dialog"
        aria-label={ru.status}
        onClick={handleFormDialogOpen('status')}
      >
        <ListItemIcon>
          <Icon className={classes[status]} />
        </ListItemIcon>
        <ListItemText primary={ru.status} secondary={ru[status]} />
      </ListItem>
      <Divider />
      <ListItem
        button
        aria-haspopup="true"
        aria-controls="form-dialog"
        aria-label={ru.dateTo}
        onClick={handleFormDialogOpen('dateTo')}
      >
        <ListItemIcon>
          <DateRangeIcon />
        </ListItemIcon>
        <ListItemText primary={ru.dateTo} secondary={formattedDate} />
      </ListItem>
    </List>
  );
};

DecisionItem.propTypes = {
  decision: Type.shape({
    userName: Type.string,
    scoringRole: Type.string,
    status: Type.oneOf(['agreed', 'notAgreed', 'noDecision']),
    limit: Type.number,
    term: Type.number,
    comment: Type.string,
    dateTo: Type.string,
  }).isRequired,
  onEdit: Type.func.isRequired,
};

export default DecisionItem;
